import { render, staticRenderFns } from "./QuizCard.vue?vue&type=template&id=206ab4f7&"
import script from "./QuizCard.vue?vue&type=script&lang=js&"
export * from "./QuizCard.vue?vue&type=script&lang=js&"
import style0 from "./QuizCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports